"use client";

import styled from "styled-components";

interface SmallTitleProps {
  $alignText?: string;
  $mb?: string;
}

export const SmallTitle = styled.h3<SmallTitleProps>`
  font-family: "Inter Medium";
  font-size: 17px;
  color: var(--textLight);
  margin-bottom: ${({ $mb }) => ($mb ? $mb : "15px")};
  text-align: ${({ $alignText }) => $alignText && $alignText};
`;
